import BigNumber from 'bignumber.js'
import numeral from 'numeral'
import { useMemo } from 'react'

import Rewards from '@/assets/rewards.png'
import WanPos from '@/assets/wanPos.png'
import { useLocalStorage } from '@/context/localstorage-context'
import { useQueryStatsInfo, useQueryTokenPrice } from '@/utils/queries'

import {
  BridgeStatistics,
  BridgeTvlInUsd,
  BridgeTvlInUsdMedia,
  Con,
  Data,
  Data1,
  Img,
  LineStyle,
  StatisticsAvg,
  StatisticsTitle,
  StatisticsTvl,
} from './Bridge.module'

export default function BridgeStatisticsModule() {
  const { theme } = useLocalStorage()
  const { data: statsInfo } = useQueryStatsInfo()
  const isdark = useMemo(() => theme === 'dark', [theme])
  const { data: tokensPrice, isLoading: tokensPriceLoading } =
    useQueryTokenPrice()

  const storemanTvl = useMemo(() => {
    if (statsInfo && statsInfo.sotremen) {
      return statsInfo.sotremen.totalDeposit
    } else {
      return 0
    }
  }, [statsInfo])

  const WanPrice = useMemo(() => {
    if (!tokensPriceLoading && tokensPrice) {
      return tokensPrice.wanchain?.usd || '0'
    } else {
      return '0'
    }
  }, [tokensPrice, tokensPriceLoading])

  const storemanTvlInUsd = useMemo(() => {
    if (statsInfo && statsInfo.sotremen) {
      const storemanTvl = new BigNumber(statsInfo.sotremen.totalDepositRaw)
        .dividedBy(Math.pow(10, 18))
        .toString(10)
      const storemanTvlNumber = numeral(storemanTvl).value()
      const usdTvl = new BigNumber(WanPrice)
        .multipliedBy(storemanTvlNumber || '0')
        .toString()
      return numeral(usdTvl).format('0,0')
    } else {
      return 0
    }
  }, [WanPrice, statsInfo])

  const storemanRewardRate = useMemo(() => {
    if (statsInfo && statsInfo.sotremen) {
      return statsInfo.sotremen.rewardRatio
    } else {
      return 0
    }
  }, [statsInfo])

  return (
    <BridgeStatistics className="bg-white dark:bg-common-1">
      <StatisticsTvl>
        <StatisticsTitle className="text-light-0 dark:text-dark-0">
          Storemen TVL
          <BridgeTvlInUsd>
            <Data1>{storemanTvlInUsd} USD</Data1>
          </BridgeTvlInUsd>
        </StatisticsTitle>
        <Con>
          <Img src={WanPos} alt="WanPos" />
          <Data>
            <div className="text-light-111 dark:text-white">
              {storemanTvl} <Data1>WAN</Data1>
            </div>
            <BridgeTvlInUsdMedia>
              <Data1>{storemanTvlInUsd} USD</Data1>
            </BridgeTvlInUsdMedia>
          </Data>
        </Con>
      </StatisticsTvl>
      <LineStyle isdark={isdark} />
      <StatisticsAvg>
        <StatisticsTitle className="text-light-0 dark:text-dark-0">
          Average APR
        </StatisticsTitle>
        <Con>
          <Img src={Rewards} alt="Rewards" />
          <Data className="text-light-222 dark:text-white">
            {storemanRewardRate}
          </Data>
        </Con>
      </StatisticsAvg>
    </BridgeStatistics>
  )
}
